export const StripeSubscriptionEventAdminFilterKey = {
  Processed: 'processed',
  Type: 'type',
} as const;

export type StripeSubscriptionEventAdminFilterKey =
  (typeof StripeSubscriptionEventAdminFilterKey)[keyof typeof StripeSubscriptionEventAdminFilterKey];

export const STRIPE_SUBSCRIPTION_EVENT_ADMIN_FILTER_KEYS = [
  StripeSubscriptionEventAdminFilterKey.Processed,
  StripeSubscriptionEventAdminFilterKey.Type,
] as const;
